import React, { useState, useEffect, useContext } from "react";
import { getDataWithToken } from "../../services/GetDataService";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TablePagination from "@mui/material/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import { AuthContext } from "../../context/AuthContext";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableContainer,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSnackbar } from "notistack";
import { customeSelectFeild } from "../../color-palette/customDesign";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { Link } from "react-router-dom";

const RefundList = () => {
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);
  const [tableDataList, setTableDataList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [refundName, setRefundName] = useState("Repair Refund");

  const [startingTime, setStartingTime] = useState(null);
  const [endingTime, setEndingTime] = useState(null);
  const [searchWord, setSearchWord] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration = vrnt === "error" ? 3000 : 1000;
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const customeTextFeild = {
    "& label": {
      fontSize: "11px",
    },
    "& label.Mui-focused": {
      color: "#0F1624",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 12px",
    },
    "& .MuiOutlinedInput-root": {
      fontSize: "13px",
      "& fieldset": {
        borderRadius: "8px",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const pageLoading = () => {
    let content = [];
    for (let i = 0; i < 10; i++) {
      content.push(
        <TableRow key={i}>
          {[...Array(6).keys()].map((e, index) => (
            <TableCell key={index}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>,
      );
    }
    return content;
  };

  const handleChangePage = (event, newPage) => {
    getData(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    getData(0, event.target.value);
    setPage(0);
  };

  const clearFilter = () => {
    setStartingTime(null);
    setEndingTime(null);
    setSearchWord("");
    setRefundName("Repair Refund");
    setPage(0);
    const newUrl = `/api/v1/transactionHistory/transaction-details-list?transaction_name=Repair Refund&limit=${rowsPerPage}&page=1`;
    getData(0, rowsPerPage, newUrl);
  };

  const getData = async (pageNO, limit, newUrl) => {
    setLoading(true);
    let newPageNO = page;
    let url;
    if (pageNO >= 0) {
      newPageNO = pageNO;
    }
    let newLimit = rowsPerPage;
    if (limit) {
      newLimit = limit;
    }
    if (newUrl) {
      url = newUrl;
    } else {
      let newStartingTime = "";
      let newEndingTime = "";

      if (startingTime !== null) {
        newStartingTime = dayjs(startingTime).format("YYYY-MM-DD");
      }
      if (endingTime !== null) {
        newEndingTime = dayjs(endingTime).format("YYYY-MM-DD");
      }

      url = `/api/v1/transactionHistory/transaction-details-list?transaction_name=${refundName}&startDate=${newStartingTime}&endDate=${newEndingTime}&searchWord=${searchWord}&limit=${newLimit}&page=${
        newPageNO + 1
      }`;
    }
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setTableDataList(allData?.data?.data || []);
      setTotalData(allData?.data?.totalData || 0);

      if ((allData?.data?.data || []).length < 1) {
        setMessage("No data found");
      }
    } else {
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Grid container columnSpacing={3} style={{ padding: "24px 0" }}>
        <Grid size={9}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{ color: "#0F1624", fontWeight: 600 }}
          >
            Refund List
          </Typography>
        </Grid>
      </Grid>
      <div
        style={{
          background: "#fff",
          border: "1px solid #EAECF1",
          borderRadius: "12px",
          overflow: "hidden",
          padding: "16px 0",
          boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{ px: 1.5, mb: 1.75 }}
          spacing={2}
        >
          <Grid size={{ xs: 12 }}>
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{ color: "#0F1624", fontWeight: 600, margin: 0 }}
            >
              Details
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                justifyContent="right"
                alignItems="center"
                spacing={1}
              >
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 3, xl: 2 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      ...customeSelectFeild,
                      "& label.Mui-focused": {
                        color: "rgba(0,0,0,0)",
                      },

                      "& .MuiOutlinedInput-input img": {
                        position: "relative",
                        top: "2px",
                      },
                    }}
                  >
                    {refundName?.length < 1 && (
                      <InputLabel
                        id="demo-simple-select-label"
                        sx={{ color: "#b3b3b3", fontWeight: 300 }}
                      >
                        Select Refund Name
                      </InputLabel>
                    )}
                    <Select
                      labelId="demo-simple-select-label"
                      id="supplierId"
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 250, // Set the max height here
                          },
                        },
                      }}
                      value={refundName}
                      // onChange={(e) => setCategoryId(e.target.value)}

                      onChange={(e) => {
                        setRefundName(e.target.value);
                        // getProducts(null, null, null, null, e.target.value);
                      }}
                    >
                      {["Repair Refund", "Warranty Refund"]?.map((item) => (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 3, xl: 2 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From Date"
                      value={startingTime}
                      onChange={(newValue) => setStartingTime(newValue)}
                      format="DD/MM/YYYY"
                      maxDate={dayjs()}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          sx: { ...customeTextFeild },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 3, xl: 2 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="To Date"
                      value={endingTime}
                      onChange={(newValue) => setEndingTime(newValue)}
                      format="DD/MM/YYYY"
                      maxDate={dayjs()}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          sx: { ...customeTextFeild },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 3, xl: 2 }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={{ lg: 1, xl: 1 }}>
                      <Grid size={4}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="info"
                          disableElevation
                          size="small"
                          sx={{ py: "4px" }}
                          onClick={clearFilter}
                        >
                          <RestartAltIcon />
                        </Button>
                      </Grid>
                      <Grid size={8}>
                        <Button
                          fullWidth
                          variant="contained"
                          disableElevation
                          color="info"
                          sx={{ py: "4px" }}
                          size="small"
                          startIcon={<SearchIcon />}
                          onClick={(event) => handleChangePage(event, 0)}
                        >
                          Search
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <div
          style={{
            overflowX: "auto",
            minWidth: "100%",
            width: "Calc(100vw - 385px)",
            boxSizing: "border-box",
          }}
        >
          <TableContainer sx={{ maxHeight: "Calc(100vh - 250px)" }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ whiteSpace: "nowrap" }}>Date</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>ID</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Transaction Name
                  </TableCell>
               
                  <TableCell style={{ whiteSpace: "nowrap" }}>Amount</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Remarks
                  </TableCell>
                  <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!loading &&
                  tableDataList?.length > 0 &&
                  tableDataList.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        {moment(row?.created_at).format("DD MMM, YYYY")}
                      </TableCell>
                      <TableCell sx={{ minWidth: "130px" }}>
                        {row?.transaction_name === "Repair Refund"
                          ? row?.transaction_source_id?.repair_id
                          : row?.transaction_source_id?.warranty_id}
                      </TableCell>
                      <TableCell sx={{ minWidth: "130px" }}>
                        {row?.transaction_name || "---------"}
                      </TableCell>
                   
                      <TableCell>
                        {row?.transaction_info
                          ? row?.transaction_info.reduce(
                              (acc, item) => acc + Number(item.amount),
                              0,
                            )
                          : row?.amount || 0}
                      </TableCell>
                      <TableCell sx={{ minWidth: "130px" }}>
                        {row?.remarks || "----------"}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          size="small"
                          variant="outlined"
                          color="info"
                          startIcon={<ListAltOutlinedIcon />}
                          component={Link}
                          to={
                            row?.transaction_name === "Repair Refund"
                              ? `/repair/details/${row?.transaction_source_id?._id}`
                              : `/repair/${row?.transaction_source_id?.repair_id}/warranty/details/${row?.transaction_source_id?._id}`
                          }
                        >
                          Details
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}

                {!loading && tableDataList?.length < 1 ? (
                  <TableRow>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      <strong> {message}</strong>
                    </TableCell>
                  </TableRow>
                ) : null}
                {loading && pageLoading()}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {tableDataList?.length > 0 ? (
          <div>
            <TablePagination
              style={{ display: "block", border: "none" }}
              rowsPerPageOptions={[]}
              count={totalData}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        ) : (
          <br />
        )}
      </div>
    </>
  );
};

export default RefundList;
